import { InAppMessage, InAppMessageContextMessage } from "../../../../model/model"
import ObjectUtil from "../../../../util/ObjectUtil"

export class InAppMessageLayoutSelector {
  select(
    inAppMessage: InAppMessage,
    condition: (message: InAppMessageContextMessage) => Boolean
  ): InAppMessageContextMessage {
    const message = inAppMessage.messageContext.messages.find(condition)
    return ObjectUtil.requiredNotNullOrUndefined(message, () => `InAppMessage must be decided [${inAppMessage.id}]`)
  }
}
